const stages = {
  stage: "Stage",
  stages: "Stages",
  add_stage: "Add Stage",
  edit_stage: "Edit Stage",
  stage_name: "Stage Name",
  name: "Name",
  status: "Status",
  actions: "Actions",
  active: "Active",
  inactive: "Inactive",
  is_active: "Active",
  edit: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  add: "Add",
  update: "Update",
  name_required: "Name is required",
  no_stages_found: "No stages found",
  delete_stage_title: "Delete Stage",
  delete_stage_description:
    "Are you sure you want to delete this stage? This action cannot be undone.",
  stage_created_successfully: "Stage created successfully",
  stage_updated_successfully: "Stage updated successfully",
  stage_deleted_successfully: "Stage deleted successfully",
  user_management: "User Management",
  something_went_wrong: "Something went wrong",
};

export default stages;
